import { render } from "./BoxDashboard.vue?vue&type=template&id=3c5a2d84"
import script from "./BoxDashboard.vue?vue&type=script&lang=js"
export * from "./BoxDashboard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__